export const LANGUAGES = [
  { code: 'es', name: 'Español', direction: 'ltr' },
  { code: 'en', name: 'English', direction: 'ltr' },
  { code: 'pt-BR', name: 'Português (Brasil)', direction: 'ltr' },
  { code: 'fr', name: 'Français', direction: 'ltr' },
  { code: 'de', name: 'Deutsch', direction: 'ltr' },
  { code: 'ar', name: 'العربية', direction: 'rtl' },
  { code: 'hi', name: 'हिन्दी', direction: 'ltr' },
  { code: 'id', name: 'Bahasa Indonesia', direction: 'ltr' },
  { code: 'tr', name: 'Türkçe', direction: 'ltr' },
  { code: 'ja', name: '日本語', direction: 'ltr' },
] as const;

export type Locale = (typeof LANGUAGES)[number]['code'];
export type LanguagePreference = Locale | 'auto';
export const DEFAULT_LOCALE: Locale = 'es';

/** Match valid BCP 47 regional variants, with Brazilian Portuguese catalog. */
export function normalizeLocale(raw: unknown): Locale | null {
  if (typeof raw !== 'string' || !raw.trim()) return null;
  try {
    const tag = new Intl.Locale(raw.trim());
    const code = tag.language === 'pt' ? 'pt-BR' : tag.language;
    return LANGUAGES.some((language) => language.code === code) ? code as Locale : null;
  } catch { return null; }
}

export function normalizePreference(raw: unknown): LanguagePreference {
  return normalizeLocale(raw) ?? 'auto';
}

export function detectBrowserLocale(languages: readonly string[] =
  typeof navigator === 'undefined' ? [] : navigator.languages): Locale {
  for (const tag of languages) {
    const code = normalizeLocale(tag);
    if (code) return code;
  }
  return DEFAULT_LOCALE;
}

export function direction(locale: Locale): 'ltr' | 'rtl' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}
